import React from "react";
import { T } from "../../../app/tokens.js";
import { ViewKey } from "../../../v2/components/ViewKey.jsx";
import { GANTT_LEGEND } from "./ganttModel.js";

const GROUPS = [
  { label: "Phases", columns: 2, items: [
    ...GANTT_LEGEND.map(phase => ({ label: phase.label, swatch: { kind: "bar", color: phase.color } })),
    { label: "End TBD", swatch: { kind: "barFade", color: T.pendingAmber } },
  ] },
  { label: "Markers", items: [
    { label: "FDOB", description: "first day of business", swatch: { kind: "diamond", color: T.dark } },
    { label: "Next milestone", description: "next open milestone due date", swatch: { kind: "dot", color: T.mid } },
    { label: "Today", swatch: { kind: "tick", color: T.red } },
  ] },
];
export function ProjectsTimelineKey() {
  return <ViewKey testId="projects-gantt-key" groups={GROUPS} footer="Phase dates are approximate (JLL New Build Schedule 10/05) unless verified. Hover a bar for dates and source." />;
}

export function ProjectsTimelineRange({ value, onChange }) {
  return <div role="group" aria-label="Timeline range" data-testid="projects-timeline-range" style={{ display: "inline-flex", flexShrink: 0, border: `1px solid ${T.border}`, borderRadius: 8, overflow: "hidden", height: 32, boxSizing: "border-box" }}>
    {[["12", "12 mo"], ["24", "24 mo"], ["all", "All"]].map(([key, label]) => <button key={key} type="button" aria-pressed={value === key} onClick={() => onChange(key)} style={{ border: 0, background: value === key ? T.blueSoft : T.card, color: value === key ? T.blue : T.mid, padding: "0 9px", fontFamily: "inherit", fontSize: T.fsSm5, fontWeight: value === key ? T.fwBold : T.fwRegular, cursor: "pointer" }}>{label}</button>)}
  </div>;
}
